import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { getBuildIdQuery } from '@ncg/data';

// Adds an icon from sprites.svg or multi-sprites.svg as post or prefix to a string. Also adds buildId automatically.
// <ncg-text-sprite-icon
//   [iconUrl]="'assets/images/sprite.svg#external-link'"
// >{{ 'map.dealer_link' | translate }}</ncg-text-sprite-icon>
@Component({
    selector: 'ncg-text-sprite-icon',
    template: `
        <ng-container *ngIf="iconFix === 'post'">
            <ng-container *ngTemplateOutlet="content"></ng-container>
        </ng-container>
        <svg-icon-sprite
            class="sprite-wrapper"
            [src]="urlWithBuildId"
            aria-hidden="true"
            [viewBox]="'0 0 30 30'"
            [width]="'1em'"
            [height]="'1em'"></svg-icon-sprite>
        <ng-container *ngIf="iconFix === 'pre'">
            <ng-container *ngTemplateOutlet="content"></ng-container>
        </ng-container>

        <ng-template #content>
            <ng-content></ng-content>
        </ng-template>
    `,
    styleUrls: ['./text-sprite-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TextSpriteIconComponent implements OnInit {
    @Input() iconUrl: string;
    @Input() iconFix: 'pre' | 'post' = 'post';
    public urlWithBuildId: string;

    public ngOnInit(): void {
        const [baseUrl, iconName] = this.iconUrl.split('#');
        this.urlWithBuildId = `${baseUrl}${getBuildIdQuery()}#${iconName}`;
    }
}
